const mutations = {
  
    SET_PROFESSOR (state, status) {

        state.setProfessor = status

    },
    ALL_MATERIAS_PROFESSOR (state, status) {

        state.allMateriasProfessor = status

    },
}

export default mutations